export interface ProductGroupPricesRequest {
	configBundleId: string;
	productGroupId: string;
}

export interface PriceDifference {
	net: number;
	gross: number;
}

export interface PricedProduct {
	id: string;
	storeId: string;
	title: string;
	description: string;
	description2: string;
	subGroupId: string;
	url: string;
	isCrmOnly: boolean;
	listPrice: number;
	promotionPrice: number;
	taxRate: number;
	customerPrice: number;
	margin: number;
	imageUrl: string;
	isApplicableForLeasing: boolean;
	navigationPath: NavigationPath[];
	averageRating: string;
	countOfReviews: string;
	manufacturerId: string;
	manufacturerName: string;
	partNumber: string;
	totalCost: number;
	pendingRelease: boolean;
	availabilityQuantity: number;
	availabilityStatus: string;
	calculatedStockQuantity: number;
	isRecommended?: boolean;
	manufacturer?: {
		imageUrl: string;
		name: string;
	};
	rating?: {
		averageRating: string;
		countOfReviews: string;
	};
	stockStatus?: {
		iconClass: string;
		description?: string;
	};
	priceDifference?: PriceDifference;
	price?: {
		net: number;
		gross: number;
	};
}

export interface NavigationPath {
	id: string;
	name: string;
	url: string;
}

export interface ProductGroupPricesResponse {
	products: PricedProduct[];
	manufacturers: string[];
	performanceComponentType?: string | null;
}

export async function fetchProductGroupPrices(
	request: ProductGroupPricesRequest
): Promise<ProductGroupPricesResponse> {
	const response = await fetch("/configure/api/getPrices", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(request),
	});

	if (!response.ok) {
		throw new Error(`Failed to fetch prices: ${response.statusText}`);
	}

	return await response.json();
}

export interface ProductGroupPriceResult {
	productGroupId: string;
	product: PricedProduct | null;
	isAvailable: boolean;
}

export interface BatchPricesResponse {
	results: ProductGroupPriceResult[];
	missingProductGroups: string[];
	deselections: string[];
}

export interface RestoreSelectionInput {
	productGroupId: string;
	productId: string | null;
}

export interface RestoreSelectionsValidationRequest {
	configBundleId: string;
	selections: RestoreSelectionInput[];
}

export interface RestoreSelectionsValidationResponse {
	selections: BatchPricesResponse;
	replacedProductGroupIds: string[];
}

export async function fetchRestoreSelectionsValidation(
	request: RestoreSelectionsValidationRequest
): Promise<RestoreSelectionsValidationResponse> {
	const response = await fetch("/configure/api/restoreSelections", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(request),
	});

	if (!response.ok) {
		throw new Error(`Failed to validate restored selections: ${response.statusText}`);
	}

	return await response.json();
}